import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env;

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.png`} alt="" />
      </Link>
      <header>
        <h2>Victor Ruiz</h2>
        <p><a href="mailto:chief.victoru@gmail.com">chief.victoru@gmail.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Victor. I&apos;m a creative thinker.
        I like to explore alternative solutions to problems,
        and I have an open mind about what will work best.
        My creativity has made me an effective team leader
        because I can anticipate problems and innovate solutions.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Victor Ruiz <Link to="/">chief-victoru.netlify.app</Link>.</p>
    </section>
  </section>
);

export default SideBar;
